module.exports = __webpack_public_path__ + "assets/2d1359d4225453ecd93788e7adbca9dc.mp3";